import "./App.css";
import "./normalize.css";
import React, { useState } from "react";
import {HashRouter, Route} from "react-router-dom";
import Main from "./components/main/Main.component";
import FixelDataContext from "./context/FixelDataContext";
import Introduction from "./components/introduction/Introduction.component";
import ErrorPage from "./components/utils/ErrorPage";
import {CustomerProvider} from "./provider/customerProvider";
import {loadStripe} from "@stripe/stripe-js/pure";
import {Elements} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  const [fullFixelData, setFullFixelData] = useState({});


    return (
        <Elements stripe={stripePromise}>
          <div className="App">
            <FixelDataContext.Provider value={{ fullFixelData, setFullFixelData }}>
                <CustomerProvider>
                  <HashRouter>
                    <Route exact path="/errorPage" component={ErrorPage} />
                    <Route exact path="/introduction" component={Introduction} />
                    <Main />
                  </HashRouter>
                </CustomerProvider>
            </FixelDataContext.Provider>
          </div>
        </Elements>
  );
}

export default App;
